// utils/itemFootprintRegistry.ts
export type ItemFootprint = { width: number; length: number };

const footprintRegistry = new Map<string, ItemFootprint>();

function getItemKey(item: any): string | undefined {
  // prefer uuid, fallback to id
  if (item?.uuid) return String(item.uuid);
  if (item?.id !== null) return String(item.id);
  return undefined;
}

export function setItemFootprint(item: any, footprint: ItemFootprint) {
  const key = getItemKey(item);
  if (!key) {
    return;
  }
  footprintRegistry.set(key, footprint);
}

export function getItemFootprint(item: any): ItemFootprint | undefined {
  const key = getItemKey(item);
  if (!key) {
    return undefined;
  }
  const fp = footprintRegistry.get(key);
  return fp;
}
